import React, { Component } from "react";
import { connect } from "react-redux";
import { checkSec, expireSession } from "../../actions/auth";
import { loadUi } from "../../actions/search";
import { getUserGlb } from "../../actions/userGlb";
import SecurityQuestionsForm from "../forms/SecurityQuestionsForm";
// import geotrust from "../../images/geotrustssl.png";
import { ERR_MSG_SESSION_EXPIRED } from "../../ErrorMessages";
import { updatePageHeaders } from "../../utils/PageHelper";
import { getContact } from "../navigation/Contact";

class SecurityQuestions extends Component {
  state = {
    respData: {},
    loading: false,
  };

  componentDidMount() {
    updatePageHeaders();
  }
  submit = (data) => {
    this.setState({ loading: true });
    return this.props
      .checkSec(data.qaList)
      .then((res) => {
        if (res.data.Status === "Error") {
          if (res.data.Message === "Answer does not match") {
            this.setState({ loading: false });
            localStorage.removeItem("sessionID");
          } else {
            this.props.expireSession(ERR_MSG_SESSION_EXPIRED);
            return;
          }
        }
        if (localStorage.sessionID) {
          this.props
            .getUserGlb()
            .then(() => {
              this.props
                .loadUi()
                .then(() => {
                  window.location.href = `/searchOptions`;
                })
                .catch((err) => {
                  console.log(
                    "Error during loadui - ",
                    err,
                    " - ",
                    err.response
                  );
                  this.setState({ loading: false });
                });
            })
            .catch((err) => {
              console.log(
                "Error while fetch user glb - ",
                err,
                " - ",
                err.response
              );
              this.setState({ loading: false });
            });
        } else {
          this.setState({ respData: res.data.QAErrorList });
        }
      })
      .catch((err) => {
        console.log("Error during checkSec", err);
        this.props.expireSession(ERR_MSG_SESSION_EXPIRED);
      });
  };

  render() {
    return (
      <div className="col-lg-12 col-md-12 col-sm-12">
        <div className="container-fluid padding-top-10">
          <div className="row security-box">
            <div className="col-lg-1" />
            <div className="col-lg-6 col-md-6 col-sm-6 login-box-left">
              <div className="security-heading">
                <strong>Security Questions</strong>
              </div>
              <div className="padding-top-20" />
              Please enter the answers to the security questions below.
              <br />
              <br />
              If you cannot remember the answers to your questions, please
              contact customer service.
              {/* <ul className="passwordHintsUL" style={{ margin: "0px 0px 5px 0px" }}>
          Hints:
          <li />Choose the questions for which you have a single, short answer.
          <li />Try to keep the answers short, so you will be able to recall
          them later exactly the way you entered them.
          <li />Double-check for accuracy such as misspellings.
        </ul>
        <br /> */}
              <div className="padding-top-20" />
              <SecurityQuestionsForm
                submit={this.submit}
                respData={this.state.respData}
                loading={this.state.loading}
              />
              <div className="padding-top-20" />
            </div>
            <div className="col-lg-1 col-md-2 col-sm-2" />
            <div className="col-lg-4 col-md-3 col-sm-3 login-box-right">
              <div className="padding-top-35">{getContact()}</div>

              <div className="padding-top-20" />

              <div className="col-lg-2 col-md-2 col-sm-2" />

              <div className="padding-top-20" />

              <div className="hide-on-smallscreen">
                <div className="padding-top-20" />

                <div className="padding-top-20" />

                <div className="padding-top-20" />
              </div>

              <div className="padding-top-20" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(null, { checkSec, expireSession, getUserGlb, loadUi })(
  SecurityQuestions
);



// WEBPACK FOOTER //
// ./src/components/pages/SecurityQuestions.js